import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import LoginPopover from '../LoginPopover';
import BZPopover from 'web-common/bizzabo-components/components/BZPopover';
import {
    sendCustomClick
} from '../../../../utils/SnowplowUtils';
import {
    buttonTypes
} from '../../../../constants/SnowplowConst';
import {
    loginClickOrigin
} from '../../../../constants/Enums';

const Props = {
    isLiked: PropTypes.bool.isRequired,
    canLike: PropTypes.bool.isRequired,
    count: PropTypes.number.isRequired,
    likeSpeakerToggle: PropTypes.func.isRequired,
    showEmailLogin: PropTypes.func.isRequired,
};

const SpeakerCommunityLike = ({
    isLiked,
    canLike,
    count,
    likeSpeakerToggle,
    eventUrls,
    showEmailLogin,
    disableLikeClick,
    setLoginV2OffsetTop,
    siteConf
}) => {
    const cls = classnames(
        'speaker-community-like margin-right-xs',
        { 'icon-liked': isLiked },
        { 'icon-like2 ': !isLiked },
        { 'cursor-pointer': canLike }
    );

    const likeButtonClickHandler = (e) => {
        const subCategory = isLiked ? 'DIS_LIKE' : 'LIKE';
        sendCustomClick(buttonTypes.likeSpeaker, subCategory, e.currentTarget);
        if (canLike && !disableLikeClick) {
            e.stopPropagation();
            likeSpeakerToggle(isLiked);
        }
    };

    return (
        <Fragment>
            <BZPopover
                disabled={canLike}
                placement="bottom"
                cls="need-login-popover"
                button={ <span>
                    <i className={cls}
                        onClick={likeButtonClickHandler}/>
                </span>}
                popover={
                    <LoginPopover
                        onLoginClick={showEmailLogin}
                        eventUrls={eventUrls}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        isWidget={siteConf?.isWidget}
                        analyticData={{
                            clickOrigin: loginClickOrigin.speaker.likeBtn,
                        }}
                    />
                }
            />

            <span>Like ({count})</span>
        </Fragment>
    );
};

SpeakerCommunityLike.propType = Props;

export default SpeakerCommunityLike;
